import { useState, useRef, useEffect } from "react";
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import Dialog from '@mui/material/Dialog';

const InfoPopup = ({ isOpen, onClose, suggestion, categoryName, category, compareYear, currentYear }) => {
    // if (!isOpen) return null;

    // const suggestions = suggestion.split('•').filter(item => item.trim() !== '');
    const suggestions = suggestion.split(/\n\s*\n/).map(item => item.trim()).filter(item => item !== '');


    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
            <div>
                <div className="mx-4 relative">
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700 absolute right-0 top-0 p-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <div className="flex justify-center my-4">
                        <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#5BB5E9] to-[#3C9DC9] flex items-center justify-center shadow-md">
                            <span className="text-2xl font-bold text-white">i</span>
                        </div>
                    </div>

                    <div className="pb-2 mb-4 text-center">
                        <h3 className="text-xl font-semibold">ข้อเสนอแนะ</h3>
                    </div>

                    <div className="p-4 mb-4 bg-gray-100 rounded-lg max-h-[400px] overflow-y-auto">
                    
                        <h4 className="font-semibold">{categoryName}</h4>
                        <p className="mb-1 text-sm text-gray-600">{category}</p>
                        {suggestions.length > 0 ? (
                            // <ul className="space-y-2 overflow-y-auto text-gray-700 list-disc list-inside h-40">
                            // {suggestions.map((item, index) => (
                            //     <li key={index} className="leading-relaxed">
                            //     {item.trim()}
                            //     </li>
                            // ))}
                            // </ul>
                            <div className="space-y-4 text-gray-800 leading-relaxed">
                            {suggestions.map((item, index) => (
                                <p key={index} className="whitespace-pre-line">
                                {item}
                                </p>
                            ))}
                            </div>
                        ) : (
                            <p className="text-gray-500">ไม่มีข้อเสนอแนะ</p>
                        )}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

const InfoPopupShowFormData = ({ isOpen, onClose }) => {
    const { control, handleSubmit, register, formState: { errors } } = useForm({
        defaultValues: {
            fields: [{ select1: '', select2: '', select3: '', select4: '', select5: '', select6: '', number1: '', number2: '', auto: '' }]
        }
    });

    const { fields, append } = useFieldArray({
        control,
        name: 'fields'
    });

    const onSubmit = (data) => {
        console.log(data);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="bg-white rounded-lg p-6 max-w-[1000px] w-full mx-4 relative">
                <div className="flex justify-center mb-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#5BB5E9] to-[#3C9DC9] flex items-center justify-center shadow-md">
                        <span className="text-2xl font-bold text-white">+</span>
                    </div>
                </div>

                <div className="pb-2 mb-4 text-center">
                    <h3 className="text-xl font-semibold">เพิ่มข้อมูล</h3>
                </div>

                <div className="p-4 mb-4 overflow-y-auto bg-gray-100 rounded-lg max-h-96">
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                        {fields.map((item, index) => (
                            <div key={item.id} className="p-4 space-y-2 bg-white border rounded-md">
                                <div className="grid grid-cols-2 gap-4">
                                    <Controller
                                        name={`fields[${index}].select1`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="p-2 border rounded-md">
                                                <option value="">Select Option 1</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                            </select>
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].select2`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="p-2 border rounded-md">
                                                <option value="">Select Option 2</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                            </select>
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].select3`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="p-2 border rounded-md">
                                                <option value="">Select Option 1</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                            </select>
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].select4`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="p-2 border rounded-md">
                                                <option value="">Select Option 2</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                            </select>
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].select5`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="p-2 border rounded-md">
                                                <option value="">Select Option 1</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                            </select>
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].select6`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="p-2 border rounded-md">
                                                <option value="">Select Option 2</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                            </select>
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].number1`}
                                        control={control}
                                        render={({ field }) => (
                                            <input {...field} type="number" className="p-2 border rounded-md" placeholder="Number 1" />
                                        )}
                                    />
                                    <Controller
                                        name={`fields[${index}].number2`}
                                        control={control}
                                        render={({ field }) => (
                                            <input {...field} type="number" className="p-2 border rounded-md" placeholder="Number 2" />
                                        )}
                                    />
                                    {/* <Controller
                                        name={`fields[${index}].auto`}
                                        control={control}
                                        render={({ field }) => (
                                            <input {...field} type="text" className="p-2 border rounded-md" placeholder="Auto" />
                                        )}
                                    /> */}
                                </div>
                                <div>
                                    <textarea
                                        {...register(`fields[${index}].description`)}
                                        placeholder="Description"
                                        className="w-full p-2 border rounded-md"
                                    ></textarea>
                                </div>
                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={() => append({ select1: '', select2: '', number1: '', number2: '', auto: '' })}
                            className="p-2 mt-4 text-white rounded-md bg-blue"
                        >
                            Add More
                        </button>
                    </form>
                </div>

                <div className="flex justify-center gap-4">
                    <button
                        onClick={onClose}
                        className="bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] w-[40%] text-white px-12 py-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        className="bg-gradient-to-r from-blue to-blue-700 w-[40%] text-white px-12 py-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

const getSubOptions = (esgType) => {
    switch(esgType) {
        case 'Environment':
            return [
                { value: 'E1', label: 'หมวดการจัดการสิ่งแวดล้อม' },
                { value: 'E2', label: 'หมวดการใช้ทรัพยากรอย่างมีประสิทธิภาพ' },
                { value: 'E3', label: 'หมวดการจัดการด้านสภาพภูมิอากาศ' }
            ];
        case 'Social':
            return [
                { value: 'S1', label: 'หมวดการเคารพสิทธิมนุษยชนและการปฎิบัติต่อแรงงานอย่างเป็นธรรม' },
                { value: 'S2', label: 'หมวดการพัฒนาศักยภาพแก่พนักงาน' },
                { value: 'S3', label: 'หมวดการจูงใจและรักษาพนักงาน' },
                { value: 'S4', label: 'หมวดสุขภาวะและความปลอดภัยในสภาพแวดล้อมการทำงาน' },
                { value: 'S5', label: 'หมวดการมีส่วนร่วมกับชุมชนและสังคม' },
                { value: 'S6', label: 'หมวดการมีส่วนร่วมของผู้มีส่วนได้เสีย' }
            ];
        case 'Governance & Economic':
            return [
                { value: 'G1', label: 'หมวดบรรษัทภิบาล' },
                { value: 'G2', label: 'หมวดจรรยาบรรณธุรกิจ ( Code of Conduct ) และการต่อต้านการทุจริต' },
                { value: 'G3', label: 'หมวดการระบุประเด็นที่เป็นสาระสำคัญของธุรกิจ ( Materiality )' },
                { value: 'G4', label: 'หมวดการบริหารความเสี่ยงและภาวะวิกฤต' },
                { value: 'G5', label: 'หมวดการบริหารจัดการความสัมพันธ์กับลูกค้า' },
                { value: 'G6', label: 'หมวดการบริหารจัดการห่วงโซ่อุปทาน' },
                { value: 'G7', label: 'หมวดการดำเนินการด้านภาษี' },
                { value: 'G8', label: 'หมวดนวัตกรรมทางธุรกิจเพื่อสังคมและ/หรือสิ่งแวดล้อม' },
                { value: 'G9', label: 'หมวดความปลอดภัยของข้อมูลและระบบสนเทศ' },
                { value: 'G10', label: 'หมวดการบริหารคุณภาพการให้บริการ' }
            ];
        default:
            return [];
    }
};

export default function ESGChart({
    title = "Assessment scores",
    subtitle = "by category",
    width = 600,
    height = 600,
    maxRayLength = 200,
    centerRadius = 50,
    showLabels = true,
    showLegend = true,
    dataEsg,
    compareData,
    compareYear,
    currentYear
}) {
    const svgRef = useRef(null);
    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 300, height: 300 });
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isPopupOpenShowFormData, setIsPopupOpenShowFormData] = useState(false);
    const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
    const [tooltip, setTooltip] = useState({
        visible: false,
        x: 0,
        y: 0,
        content: "",
    });
    const [isGroupNameSaved, setIsGroupNameSaved] = useState(false);
    const [selectedSuggestion, setSelectedSuggestion] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [nameSubType, setNameSubType] = useState('');

    // Add resize observer
    useEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                setDimensions({
                    width: Math.min(width, height),
                    height: Math.min(width, height)
                });
            }
        });

        resizeObserver.observe(containerRef.current);
        return () => resizeObserver.disconnect();
    }, []);

    // Update chart dimensions
    const chartWidth = dimensions.width;
    const chartHeight = dimensions.height;
    const chartMaxRayLength = (chartWidth * maxRayLength) / chartWidth;
    const chartCenterRadius = (chartWidth * centerRadius) / chartWidth;
    const centerX = chartWidth / 2;
    const centerY = chartHeight / 2;
    const backgroundRadius = chartMaxRayLength + 60; 


    const data = dataEsg ? dataEsg.reduce((acc, item) => {
        const scoreItem = item.item.find(i => i.startsWith('Score: '));
        const score = scoreItem ? parseInt(scoreItem.replace('Score: ', '')) : 0;

        let categoryId = '';
        let categoryLabel = '';
        let percentage = 0
        
        if (item.name.includes('Environment')) {
            categoryId = 'E';
            categoryLabel = 'Environment (E)';
            percentage = 20
        } else if (item.name.includes('Social')) {
            categoryId = 'S';
            categoryLabel = 'Social (S)';
            percentage = 30
        } else if (item.name.includes('Governance')) {
            categoryId = 'G';
            categoryLabel = 'Governance (G)';
            percentage = 50
        }

        const subTypeName = item?.rawData?.esgType && item?.rawData?.subType && (() => {
            const options = getSubOptions(item.rawData.esgType);
            const selectedOption = options.find(opt => opt.value === item.rawData.subType);
            return selectedOption ? `${selectedOption.label}` : '';
        })();
        
        // Create metrics data
        const metrics = item.rawData && item.rawData.topic_list ? 
            (() => {
                if (!compareData || compareData.length === 0) {
                    return [{
                        name: subTypeName, 
                        valueA: score,
                        valueB: 0,
                        suggestion: item.rawData.suggestion || '',
                        categoryName: item.name,
                        topicList: item.rawData.topic_list,
                        subTypeName: subTypeName,
                        compareYear: compareYear
                    }];
                }
                
                const compareItem = compareData.find(compareItem => 
                    compareItem.name === item.name && 
                    compareItem.rawData?.subType === item.rawData?.subType
                );
                
                if (compareItem) {
                    return [{
                        name: subTypeName, 
                        valueA: score,
                        valueB: compareItem.item.find(i => i.startsWith('Score: '))?.replace('Score: ', '') || 0,
                        suggestion: item.rawData.suggestion || '',
                        categoryName: item.name,
                        topicList: item.rawData.topic_list,
                        subTypeName: subTypeName,
                        compareYear: compareYear
                    }];
                }
                return [];
            })() : [];
        
        const existingCategoryIndex = acc.findIndex(cat => cat.id === categoryId);
        
        if (existingCategoryIndex >= 0) {
            acc[existingCategoryIndex].metrics = [...acc[existingCategoryIndex].metrics, ...metrics];
            acc[existingCategoryIndex].percentage = percentage;
        } else {
            acc.push({
                id: categoryId,
                label: categoryLabel,
                color: item.color,
                percentage: percentage,
                metrics: metrics
            });
        }
        
        return acc;
    }, []) : [];

  
    // const centerX = width / 2;
    // const centerY = height / 2;

    const totalPercentage = data.reduce((sum, category) => sum + category.percentage, 0);


    const categoryAngles = data.map((category, index) => {
       // If there's only one category, it should take up the full circle
       const normalizedPercentage = data.length === 1 ? 100 : (category.percentage / totalPercentage) * 100;
       const startAngle = data.length === 1 ? 0 : 
           index === 0 ? 0 : data.slice(0, index).reduce((sum, cat) => sum + (cat.percentage / totalPercentage) * 360, 0);

       const endAngle = data.length === 1 ? 360 : startAngle + (normalizedPercentage / 100) * 360;

        return {
            ...category,
            startAngle,
            endAngle,
        };
    });

    // Function to generate a pie segment path
    const generatePieSegment = (startAngle, endAngle) => {
        const startRadians = (startAngle - 90) * (Math.PI / 180);
        const endRadians = (endAngle - 90) * (Math.PI / 180);

        const startX = centerX + Math.cos(startRadians) * chartCenterRadius;
        const startY = centerY + Math.sin(startRadians) * chartCenterRadius;
        const endX = centerX + Math.cos(endRadians) * chartCenterRadius;
        const endY = centerY + Math.sin(endRadians) * chartCenterRadius;

        const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

        return `M ${centerX} ${centerY} L ${startX} ${startY} A ${chartCenterRadius} ${chartCenterRadius} 0 ${largeArcFlag} 1 ${endX} ${endY} Z`;
    };

    // Function to handle tooltip positioning
    useEffect(() => {
        const handleMouseMove = (e) => {
            if (tooltip.visible) {
                setTooltip((prev) => ({
                    ...prev,
                    x: e.clientX,
                    y: e.clientY,
                }));
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [tooltip.visible]);

    const handleSaveGroupName = () => {
        setIsGroupNameSaved(true);
    };

     let latestYear;
    if (typeof currentYear === 'string') {
    latestYear = Math.max(...currentYear.split(',').map(Number));
    } else if (Array.isArray(currentYear)) {
    latestYear = Math.max(...currentYear.map(Number));
    } else if (typeof currentYear === 'number') {
    latestYear = currentYear;
    } else {
    latestYear = undefined;
    }


    return (
        <div className=" max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-4xl min-h-[200px] sm:min-h-[300px] md:min-h-[400px] mx-auto flex flex-col"
        // className="flex flex-col w-full h-full"
        >
            {/* <div className="flex items-center justify-between">
                <h1 className="text-xl">ESG Report</h1>
                {isGroupNameSaved ? (
                    <span className="text-lg">{groupName}</span>
                ) : (
                    <div className="flex items-center">
                        <input
                            type="text"
                            value={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                            placeholder="Enter Group Name"
                            className="p-2 mr-2 border rounded-md"
                        />
                        <button
                            onClick={handleSaveGroupName}
                            className="p-2 text-white bg-blue-500 rounded-md"
                        >
                            Submit
                        </button>
                    </div>
                )}
            </div> */}

            {title && (
                <div className="p-2">
                    <div className="text-xl">{title}</div>
                    {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
                </div>
            )}

            <div ref={containerRef} className="relative flex items-start justify-center flex-1 pt-2">
                <div  className="relative w-full aspect-square h-[60vw] sm:h-[400px] md:h-[500px] lg:h-[600px] max-h-[80vw] sm:max-h-[400px] md:max-h-[500px] lg:max-h-[600px]"
                // className="relative w-full h-full" style={{ aspectRatio: '1/1' }}
                >
                    {/* Button to open the info popup */}
                    {/* <button
                        onClick={() => setIsPopupOpen(true)}
                        className="absolute -top-2 -left-4 inline-flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#5BB5E9] to-[#3C9DC9] text-white text-lg shadow-md hover:opacity-90 transition-opacity z-10"
                    >
                        i
                    </button> */}

                    
                    {/* <button
                        onClick={() => setIsPopupOpenShowFormData(true)}
                        className="absolute -top-2 left-24 inline-flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#5BB5E9] to-[#3C9DC9] text-white text-lg shadow-md hover:opacity-90 transition-opacity z-10"
                    >
                        +
                    </button> */}

                    {/* Button to open the new popup */}
                    {/* <button
                        onClick={() => setIsNewPopupOpen(true)}
                        className="absolute z-10 inline-flex items-center justify-center w-8 h-8 text-lg text-white transition-opacity transform -translate-x-1/2 -translate-y-1/2 rounded-full shadow-md top-1/2 left-1/2 bg-gradient-to-r from-red-500 to-red-700 hover:opacity-90"
                    >
                        ++
                    </button> */}

                    {/* SVG chart */}
                    <svg
                        ref={svgRef}
                        width={chartWidth}
                        height={chartHeight}
                        viewBox={`0 0 ${chartWidth} ${chartHeight}`}
                        className="w-full h-full -mt-16 overflow-visible"
                    >
                        {/* Background circle */}
                        <circle cx={centerX} cy={centerY} r={backgroundRadius} fill="none" stroke="#f0f0f0" strokeWidth="1" />

                        {/* Background sectors for each category */}
                        {categoryAngles?.map((category) => {
                            const startRadians = (category.startAngle - 90) * (Math.PI / 180);
                            const endRadians = (category.endAngle - 90) * (Math.PI / 180);

                            // If there's only one category, draw a full circle instead of a sector
                            if (data.length === 1) {
                                return (
                                    <circle
                                        key={`sector-${category.id}`}
                                        cx={centerX}
                                        cy={centerY}
                                        r={backgroundRadius}
                                        fill={`${category.color}15`}
                                        stroke="none"
                                    />
                                );
                            }

                            const startX = centerX + Math.cos(startRadians) * backgroundRadius;
                            const startY = centerY + Math.sin(startRadians) * backgroundRadius;
                            const endX = centerX + Math.cos(endRadians) * backgroundRadius;
                            const endY = centerY + Math.sin(endRadians) * backgroundRadius;

                            const largeArcFlag = category.endAngle - category.startAngle > 180 ? 1 : 0;

                            return (
                                <path
                                    key={`sector-${category.id}`}
                                    d={`M ${centerX} ${centerY} L ${startX} ${startY} A ${backgroundRadius} ${backgroundRadius} 0 ${largeArcFlag} 1 ${endX} ${endY} Z`}
                                    fill={`${category.color}15`}
                                    stroke="none"
                                />
                            );
                        })}

                        {/* Generate rays for each category */}
                        {categoryAngles.map((category) => {
                            const angleRange = category.endAngle - category.startAngle;
                            const metricsCount = category.metrics.length;

                            // ฟังก์ชันคำนวณความกว้างลิ่มตามความยาวลิ่ม
                            const maxArcWidth = 0;
                            const minArcWidth = 8;
                            function calcArcWidth(rayLength) {
                                const maxLength = chartMaxRayLength;
                                return Math.max(minArcWidth, (rayLength / maxLength) * maxArcWidth);
                            }


                            return category.metrics.map((metric, metricIndex) => {
                                const angle = category.startAngle + (angleRange / metricsCount) * (metricIndex + 0.5);
                                const radians = (angle - 90) * (Math.PI / 180);
                                const offsetRadians = 0.07; // มุมเยื้องสำหรับ Value B


                                 // คำนวณความยาวลิ่ม
                                const rayALength = (metric.valueA / 100) * chartMaxRayLength;
                                const rayBLength = (metric.valueB / 100) * chartMaxRayLength;

                                // คำนวณความกว้างลิ่มตามความยาวลิ่ม
                                const arcWidthA = calcArcWidth(rayALength);
                                const arcWidthB = calcArcWidth(rayBLength);

                                // คำนวณจุดฐานและปลายสำหรับ Value A
                                const rayBaseX = centerX + Math.cos(radians) * chartCenterRadius;
                                const rayBaseY = centerY + Math.sin(radians) * chartCenterRadius;
                                // ปลาย ray (รวมระยะจากขอบ pie ไปยังปลาย)
                                const rayLength = (metric.valueA / 100) * chartMaxRayLength;
                                const rayTipX = centerX + Math.cos(radians) * (chartCenterRadius + rayLength);
                                const rayTipY = centerY + Math.sin(radians) * (chartCenterRadius + rayLength);

                                // ความกว้างปลาย ray
                                const arcWidth = calcArcWidth(rayLength);
                                const tipLeftX = rayTipX + Math.cos(radians - Math.PI / 2) * arcWidth;
                                const tipLeftY = rayTipY + Math.sin(radians - Math.PI / 2) * arcWidth;
                                const tipRightX = rayTipX + Math.cos(radians + Math.PI / 2) * arcWidth;
                                const tipRightY = rayTipY + Math.sin(radians + Math.PI / 2) * arcWidth;


                                // คำนวณจุดฐานและปลายสำหรับ Value B (เยื้องมุม)
                                const rayBaseBX = centerX + Math.cos(radians + offsetRadians) * chartCenterRadius;
                                const rayBaseBY = centerY + Math.sin(radians + offsetRadians) * chartCenterRadius;

                                const rayTipBX = centerX + Math.cos(radians + offsetRadians) * (chartCenterRadius + rayBLength);
                                const rayTipBY = centerY + Math.sin(radians + offsetRadians) * (chartCenterRadius + rayBLength);
                                const rayTipLeftBX = rayTipBX + Math.cos(radians + offsetRadians - Math.PI / 2) * arcWidthB;
                                const rayTipLeftBY = rayTipBY + Math.sin(radians + offsetRadians - Math.PI / 2) * arcWidthB;
                                const rayTipRightBX = rayTipBX + Math.cos(radians + offsetRadians + Math.PI / 2) * arcWidthB;
                                const rayTipRightBY = rayTipBY + Math.sin(radians + offsetRadians + Math.PI / 2) * arcWidthB;

                                const colorB = `${category.color}33`; // 25% opacity
                                const colorA = `${category.color}cc`; // 56% opacity

                                return (
                                    <g key={`${category.id}-${metricIndex}`}>
                                        {/* Long ray (Value B) */}
                                        {compareData?.length > 0 && (
                                            <path
                                                d={`
                                                    M ${rayBaseBX} ${rayBaseBY}
                                                    L ${rayTipLeftBX} ${rayTipLeftBY}
                                                    A ${arcWidthB} ${arcWidthB} 0 0 1 ${rayTipRightBX} ${rayTipRightBY}
                                                    Z
                                                `}
                                                fill={colorB}
                                                onClick={() => {
                                                    setSelectedSuggestion(metric.suggestion || '');
                                                    setSelectedCategory(compareYear ? `${metric.categoryName} (${compareYear})` : metric.categoryName);
                                                    setNameSubType(metric.subTypeName || '');
                                                    setIsPopupOpen(true);
                                                }}
                                                onMouseEnter={() => {
                                                    setTooltip({
                                                        visible: true,
                                                        x: 0,
                                                        y: 0,
                                                        content: compareYear ? `${metric.name}: ${metric.valueB} (${compareYear})` : `${metric.name}: ${metric.valueB}`,
                                                    });
                                                }}
                                                onMouseLeave={() => {
                                                    setTooltip((prev) => ({ ...prev, visible: false }));
                                                }}
                                            />
                                        )}

                                        {/* Short ray (Value A) */}
                                        <path
                                            d={`
                                                M ${rayBaseX} ${rayBaseY}
                                                L ${tipLeftX} ${tipLeftY}
                                                A ${arcWidth} ${arcWidth} 0 0 1 ${tipRightX} ${tipRightY}
                                                Z
                                            `}
                                            fill={colorA}
                                            onClick={() => {
                                                setSelectedSuggestion(metric.suggestion || '');
                                                setSelectedCategory(compareYear ? `${metric.categoryName} (${latestYear})` : metric.categoryName);
                                                setNameSubType(metric.subTypeName || '');
                                                setIsPopupOpen(true);
                                            }}
                                            onMouseEnter={() => {
                                                setTooltip({
                                                    visible: true,
                                                    x: 0,
                                                    y: 0,
                                                    content: compareYear ? `${metric.name}: ${metric.valueA} (${latestYear})` : `${metric.name}: ${metric.valueA}`,
                                                });
                                            }}
                                            onMouseLeave={() => {
                                                setTooltip((prev) => ({ ...prev, visible: false }));
                                            }}
                                        />
                                    </g>
                                );
                            });
                        })}


                        {/* Center pie chart */}
                        {categoryAngles.map((category) => {
                            // If there's only one category, draw a full circle instead of a sector
                            if (data.length === 1) {
                                return (
                                    <circle
                                        key={`pie-${category.id}`}
                                        cx={centerX}
                                        cy={centerY}
                                        // r={centerRadius}
                                        r={chartCenterRadius}
                                        fill={category.color}
                                    />
                                );
                            }

                            return (
                                <path
                                    key={`pie-${category.id}`}
                                    d={generatePieSegment(category.startAngle, category.endAngle)}
                                    fill={category.color}
                                />
                            );
                        })}

                        {/* Center labels */}
                        {showLabels &&
                            categoryAngles.map((category) => {
                                const midAngle = (category.startAngle + category.endAngle) / 2;
                                const midRadians = (midAngle - 90) * (Math.PI / 180);
                                // const labelRadius = centerRadius * 0.6;
                                const labelRadius = chartCenterRadius * 0.6;
                                const labelX = centerX + Math.cos(midRadians) * labelRadius;
                                const labelY = centerY + Math.sin(midRadians) * labelRadius;

                                return (
                                    <text
                                        key={`label-${category.id}`}
                                        x={labelX}
                                        y={labelY}
                                        textAnchor="middle"
                                        dominantBaseline="middle"
                                        fill="white"
                                        fontSize="16"
                                        fontWeight="bold"
                                    >
                                        {category.id}
                                    </text>
                                );
                            })}
                    </svg>

                    {/* Tooltip */}
                    {tooltip.visible && (
                        <div
                            className="absolute z-10 w-56 px-3 py-1 text-sm text-white bg-gray-800 rounded shadow-lg pointer-events-none"
                            style={{
                                left: tooltip.x + 10,
                                top: tooltip.y - 30,
                                transform: "translateX(-50%)",
                            }}
                        >
                            {tooltip.content}
                        </div>
                    )}
                </div>
            </div>

            {showLegend && (
                <div className="flex flex-wrap justify-center gap-6 pb-4 -mt-16">
                    {data.map((category) => (
                        <div key={`legend-${category.id}`} className="flex items-center">
                            <div className="w-3 h-3 mr-2 rounded-full" style={{ backgroundColor: category.color }}></div>
                            <span className="text-sm">{category.label}</span>
                        </div>
                    ))}
                </div>
            )}

            <InfoPopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                suggestion={selectedSuggestion}
                categoryName={selectedCategory}
                category={nameSubType}
                currentYear={currentYear}
                compareYear={compareYear}
            />

            <InfoPopupShowFormData
                isOpen={isPopupOpenShowFormData}
                onClose={() => setIsPopupOpenShowFormData(false)}
            />

            <InfoPopupShowFormData
                isOpen={isNewPopupOpen}
                onClose={() => setIsNewPopupOpen(false)}
            />
        </div>
    );
}
